export default {
  placeholder: 'Pesquisar',
  cancel: 'Cancelar',
};
